module.exports = __webpack_public_path__ + "img/starfighter.b4278072.svg";